module.exports = __webpack_public_path__ + "static/media/halfcircleglobe.1973e8ae.jpg";